import React, { Component, Fragment } from "react";

class HomeVideos extends Component {

  render() {
    return (
      <Fragment>

        <div className="container text-center mt-5">

          <h2 className="section-title">
            Our Latest Videos
          </h2>

          <div className="row mt-4">

            <div className="col-md-6 mb-4">
           <iframe width="560" height="315" 
           src="https://www.youtube.com/embed/RmfcGoXvMXc?si=7I6dyFiwUA2_Jbyp" 
           title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; 
           clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
           referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>



           <div className="col-md-6 mb-4">
           <iframe width="560" height="315" 
           src="https://www.youtube.com/embed/vRm-B9vG0Nw?si=Qup51bwUbT-D4sK-" 
           title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; 
           clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
           referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
            






          </div>

        </div>

      </Fragment>
    );
  }
}

export default HomeVideos;